export default "/images/HDAW_STEP_4.png";